// extracted by mini-css-extract-plugin
module.exports = {"hide":"BookInfo_hide__3V7uw","rtBookInfo":"BookInfo_rtBookInfo__2_lkX","rtInfoCard":"BookInfo_rtInfoCard__3HvWd","title":"BookInfo_title__1kFYg","text":"BookInfo_text__cClNP"};